import React from 'react';
import {
  FormControl,
  InputLabel,
  Select as MuiSelect,
  MenuItem,
  FormHelperText,
} from '@material-ui/core';

export default function Select({
  name,
  label,
  value,
  error = null,
  disabled = false,
  onChange,
  options,
}) {
  return (
    <FormControl
      variant='outlined'
      {...(error && { error: true })}
      disabled={disabled}
    >
      <InputLabel>{label}</InputLabel>
      <MuiSelect label={label} name={name} value={value} onChange={onChange}>
        {options.map((item) => (
          <MenuItem key={item.value} value={item.title}>
            {/* <MenuItem key={item.id} value={item.id}> */}
            {item.title}
          </MenuItem>
        ))}
      </MuiSelect>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}
